export default __webpack_public_path__ + "static/media/51.42e7e062.jpg";